// extracted by mini-css-extract-plugin
export default {"container":"_0aYKV0G1--styles_container__uC3YL","wiggle":"_0aYKV0G1--styles_wiggle__C0ma3","shimmer":"_0aYKV0G1--styles_shimmer__Rh6Gy"};